import {Component, Input, OnInit} from '@angular/core';
import {Product} from "../../app.models";
import {PriceViewService} from "../price-view/price-view.service";

@Component({
  selector: 'app-price',
  templateUrl: './price.component.html',
  styleUrls: ['./price.component.scss']
})
export class PriceComponent implements OnInit {


  @Input() product: Product;

  public HideSupplierPrice = true;
  constructor(public priceViewService: PriceViewService) { }

  ngOnInit(): void {
  }

  mouseup() {
    this.HideSupplierPrice = false;
  }

  mousedown() {
    this.HideSupplierPrice = true;
  }
}
